export default {"src":"/_next/static/media/np_log-out.4a8a3233.svg","height":133,"width":133,"blurWidth":0,"blurHeight":0};